export default "__VITE_ASSET__CECUgdu9__"